module.exports = __webpack_public_path__ + "img/1.e0393942.gif";